// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'api';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M12.52 10.287a3.958 3.958 0 0 0 4.025-3.89 3.959 3.959 0 0 0-4.024-3.89c-.341 0-.68.042-1.01.124A3.7 3.7 0 0 0 8.16.562 3.641 3.641 0 0 0 4.486 3.82a3.287 3.287 0 0 0-3.032 3.225 3.3 3.3 0 0 0 3.353 3.241zm2.664 7.151v-4.9m-.98-.001h1.96m-1.96 4.901h1.96m-7.841 0v-1.96m.002-.001h1.47a1.47 1.47 0 0 0 0-2.94h-1.47zm-6.863 1.961.553-3.69a1.425 1.425 0 0 1 2.814 0l.553 3.69m-3.663-1.716h3.406'
  />
);

export const viewBox = '0 0 18 18';
